import { useQuery } from "@tanstack/react-query"

import { fetchMyUsage } from "@/api/fair-use"
import { queryKeys } from "@/lib/query-keys"

/**
 * The current user's fair-use snapshot (GET /api/me/usage).
 *
 * Deliberately no polling: after the initial fetch the cache is kept fresh by
 * the `fair_use` metadata routed from each completed WS answer
 * (fair-use-ws-bridge.ts) and invalidated after a request-more submission.
 */
export function useMyUsage() {
  return useQuery({
    queryKey: queryKeys.fairUseMyUsage,
    queryFn: fetchMyUsage,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 1,
    retryDelay: 1000,
  })
}
